//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import pdpUrlEditorTemplate from '@partials/bv-params/pdp-url-editor.html';

(function () {
  const curalate = angular.module('curalate');

  curalate.directive('pdpUrlEditor', () => ({
    restrict: 'E',
    scope: {
      product: '<',
      onClose: '&',
      onSave: '&',
    },
    template: pdpUrlEditorTemplate,
    controller: 'PdpUrlEditorController',
    controllerAs: 'ctrl',
    bindToController: true,
  }));

  curalate.controller('PdpUrlEditorController', [
    '$scope',
    '$q',
    'UniversalImageActionsApiService',
    function ($scope, $q, UniversalImageActionsApiService) {
      this.model = {
        product: this.product,
      };

      this.isSaving = false;
      this.error = null;

      this.onSaveClicked = function () {
        var self = this;
        self.error = null;
        self.isSaving = true;

        var newPdpUrl = this.model.product.destinationUrl;

        // Get the external ID from the productStyleId, everything that is after the first colon
        // Example: bv_democlientx:test-id -> test-id
        var externalId = this.model.product.productStyleId.split(':')[1];

        UniversalImageActionsApiService.updateBvProductPdpUrl(
          externalId,
          newPdpUrl,
        )
          .then(function () {
            self.isSaving = false;
            self.product.destinationUrl = newPdpUrl;
            self.onSave({ product: self.product });
          })
          .catch(function () {
            self.isSaving = false;
            self.error =
              'Failed to update PDP URL. Check your URL and try again.';
            $scope.$apply();
          });
      };

      this.onCancelClicked = function () {
        this.onClose();
      };
    },
  ]);
})();
